exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".modal-content {\n  height: 100%;\n  max-height: calc(100vh - 135px);\n  overflow-x: auto;\n  overflow-y: auto;\n  border: none;\n}\n\n.modal-content td {\n  vertical-align: top;\n}", ""]);

